import request from './request'

export function getCashierPresentation(cashierNo, clientType) {
  return request.get(`/open/cashier/${cashierNo}`, {
    params: { clientType }
  })
}

export function createCashierScan(cashierNo, data) {
  return request.post(`/open/cashier/${cashierNo}/scan`, data)
}

export function createCashierEbank(cashierNo, data) {
  return request.post(`/open/cashier/${cashierNo}/ebank`, data)
}

export function createCashierTransfer(cashierNo, data) {
  return request.post(`/open/cashier/${cashierNo}/bank-transfer`, data)
}

export function getCashierStatus(cashierNo, attemptNo) {
  return request.get(`/open/cashier/${cashierNo}/status`, {
    params: { attemptNo }
  })
}

export function createCashierOrder(data) {
  return request.post('/payment/cashier', data)
}

export function createOrGetCashierByBilling(billingId) {
  return request.post(`/payment/cashier/by-billing/${billingId}`)
}
